import { type Dayjs } from 'dayjs';

import { MDText } from 'i18n-react';

import dayjs from 'Utilities/dayjs';

import Texts from './LiveSaleHeader.texts.json';

const LocalT = new MDText(Texts);

const UK_TIMEZONE = 'Europe/London';
const LIVE_SALE_STARTS_AT = '16:30';
const LIVE_SALE_ENDS_AT = '15:30';

const getUkTimeOnDay = (day: Dayjs, time: string) => dayjs.tz(`${day.format('YYYY-MM-DD')} ${time}`, UK_TIMEZONE);

const getMinutesUntilNextUkTime = (now: Dayjs, time: string) => {
  const today = getUkTimeOnDay(now, time);
  const target = now.isBefore(today) ? today : getUkTimeOnDay(now.add(1, 'day'), time);

  return target.diff(now, 'minute');
};

export const getLiveSaleMinutesLeft = (date: Date): number | null => {
  const now = dayjs(date).tz(UK_TIMEZONE);
  const isBetweenSales = !now.isBefore(getUkTimeOnDay(now, LIVE_SALE_ENDS_AT))
    && now.isBefore(getUkTimeOnDay(now, LIVE_SALE_STARTS_AT));

  return isBetweenSales ? null : getMinutesUntilNextUkTime(now, LIVE_SALE_ENDS_AT);
};

export const getMinutesUntilSaleStarts = (date: Date): number => (
  getMinutesUntilNextUkTime(dayjs(date).tz(UK_TIMEZONE), LIVE_SALE_STARTS_AT)
);

const toHoursAndMinutes = (totalMinutes: number) => ({
  hours: Math.floor(totalMinutes / 60),
  minutes: totalMinutes % 60,
});

export const formatLiveSaleTimeLeft = (minutesLeft: number) => (
  LocalT.translate('live.timeLeft', toHoursAndMinutes(minutesLeft)) as string
);

export const formatSaleStartsIn = (minutesLeft: number) => (
  LocalT.translate('readyForSale.title', toHoursAndMinutes(minutesLeft)) as string
);
